import { LoginModal } from 'components/modals/LoginModal'
import { OnBoardingCard } from 'components/OnBoardingCard'
import { useLocation, useNavigate } from 'react-router'
import { OnBoardingContainer } from 'components/ui/OnBoardingContainer'

export const LoginPage = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const from = state?.from as Location | undefined

  const onSuccessLogin = () => {
    if (from) {
      return navigate(from.pathname)
    }
    navigate('/authenticated/areas')
  }

  return (
    <OnBoardingContainer>
      <OnBoardingCard>
        <LoginModal
          onSuccess={onSuccessLogin}
          onResetPassword={() => {
            navigate('/reset-password')
          }}
        />
      </OnBoardingCard>
    </OnBoardingContainer>
  )
}
